import { useTranslation } from "react-i18next";
import { InfoIcon } from "src/assets/Icons";
import { useSSRContext } from "../../context/SSRContext";

const DISCLAIMER_KEYS = {
  seats: "Flights.details.ssr.seatsDisclaimer",
  baggages: "Flights.details.ssr.baggagesDisclaimer",
  meals: "Flights.details.ssr.mealsDisclaimer",
};

export default function SSRDisclaimers() {
  const { cursor } = useSSRContext();
  const { t } = useTranslation();

  if (!cursor.ssrType) return null;

  const points = t(DISCLAIMER_KEYS[cursor.ssrType], { returnObjects: true }) as string[];

  return (
    <div className="flex flex-col gap-2 rounded-md border border-border-active bg-background-default p-4">
      <div className="flex items-center gap-2 text-font-active font-semibold">
        <InfoIcon />
        {t("Flights.details.ssr.disclaimer")}
      </div>
      <ul className="flex flex-col gap-1 list-disc ps-5 text-sm text-font-subtle">
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
}
